import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { STATUS_MESSAGE } from '../lib/Error';
import * as api from '../lib/api/api';
import { checkAuth } from '../lib/util/Authenticate';
import * as PATH from '../lib/routes/path';
import useError from './useError';

const useEventVoucher = () => {
  const history = useHistory();
  const { onAlertStatusError } = useError();
  const [isLoading, setIsLoading] = useState(false);

  const postEventVoucher = useCallback(({ code }) => {
    const message = STATUS_MESSAGE.voucher;
    if (checkAuth(true)) {
      setIsLoading(true);
      api
        .postVoucherCoupon({ code })
        .then((response) => alert(message[200]))
        .catch((error) => {
          onAlertStatusError({ message, error });
        })
        .finally(() => setIsLoading(false));
    } else {
      history.push(PATH.SIGNIN);
    }
  }, []);

  const onClickEventButton = useCallback((event) => {
    const { type, code, path, onClick, params } = event;

    type === 'voucher' && postEventVoucher({ code });
    type === 'route' && history.push(path);
    type === 'action' && onClick(params);
  }, []);

  const [active, setActive] = useState(true);

  const onSetCouponButton = useCallback(({ code }) => {
    postEventVoucher({ code });
    setActive(false);
  }, []);

  return { onClickEventButton, onSetCouponButton, active, isLoading };
};

export default useEventVoucher;
